import { render, staticRenderFns } from "./SavedVehicleSelection.vue?vue&type=template&id=a5bff7c6&scoped=true"
import script from "./SavedVehicleSelection.vue?vue&type=script&lang=js"
export * from "./SavedVehicleSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bff7c6",
  null
  
)

export default component.exports